import { css } from '@emotion/core';
import { Checkbox, Modal, Skeleton } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import contentStyle from '@/src/cms/contentStyle';
import Button from '@/src/shared/components/Button';
import Heading from '@/src/shared/components/Heading';
import Sanitize from '@/src/shared/components/Sanitize';
import { space } from '@/styles';

const { m } = space;

const style = {
  modalContainer: css`
    width: 100% !important;
    max-width: 769px;
    shadow-box: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    .ant-modal-body {
      max-height: 600px;
      overflow: scroll;
    }
  `,
  titleContainer: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,
  footer: css`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 10px;
    > button {
      margin-left: 10px;
    }
  `,
};

const TermsConditionModal = props => {
  const {
    data: { Body, MetaTitle },
    loading,
    visible,
    handleAccept,
  } = props;
  const [checked, setChecked] = useState(false);

  return (
    <Modal
      visible={visible}
      closable={false}
      css={style.modalContainer}
      maskStyle={{ backgroundColor: 'rgba(0, 38, 73, 0.95)' }}
      title={
        <span css={style.titleContainer}>
          <Heading type={3} weight="bolder" theme="primaryGray">
            {MetaTitle}
          </Heading>
        </span>
      }
      footer={
        <div css={style.footer}>
          <Checkbox checked={checked} onChange={e => setChecked(e.target.checked)}>
            Accept Terms & Conditions
          </Checkbox>
          <Button size="small" disabled={!checked} onClick={handleAccept}>
            Continue
          </Button>
        </div>
      }
    >
      {loading ? (
        <Skeleton paragraph={{ rows: 8 }} active />
      ) : (
        <div css={contentStyle}>
          <Sanitize mildwest>{Body}</Sanitize>
        </div>
      )}
    </Modal>
  );
};

TermsConditionModal.propTypes = {
  visible: PropTypes.bool.isRequired,
};

export default TermsConditionModal;
